import autosize from 'autosize';

/**
 * Integriert autosize, eine Bibliothek zum automatischen
 * resizen von TextAreas
 */
export default function () {
	autosize(document.querySelectorAll('.SP-Field--textarea textarea'));
}
